<div class="dialog-container sai-dialog-shell" cdkScrollable [dir]="lang === 'en' ? 'ltr' : 'rtl'" *transloco="let t">
    <app-sai-dialog-header
        icon="heroicons_outline:funnel"
        [title]="t('Filter Tracker')"
        [subtitle]="t('Configure dimension filters')"
        (closed)="closeDialog()"
    ></app-sai-dialog-header>

    <div class="dialog-body w-full max-w-full overflow-y-hidden">
        <div class="flex flex-col gap-3 sm:gap-4">
            @if(dimensionColumns.length > 0){
                <ng-container>
                    <mat-select-search
                        [width]="'w-full'"
                        [options]="dimensionColumns"
                        [placeholder]="t('Choose dimensions to filter')"
                        [label]="t('Dimension Columns')"
                        [multiple]="true"
                        [searchPlaceholder]="''"
                        [displayField]="'fieldName'"
                        [valueField]="'columnName'"
                        [formControl]="dimensionCtrl"
                    >
                    </mat-select-search>
                </ng-container>
            }
            @for(fieldName of dimensionCtrl.value;track $index){
                <ng-container>
                    @if(dropdownFormControls[fieldName] && distinctItems[fieldName]){
                        <ng-container>
                            <mat-select-search
                                [width]="'w-full'"
                                [options]="distinctItems[fieldName]"
                                [placeholder]="t('Choose items')"
                                [label]="fieldName"
                                [multiple]="true"
                                [selectAll]="true"
                                [searchPlaceholder]="''"
                                [displayField]="'value'"
                                [valueField]="'id'"
                                [formControl]="dropdownFormControls[fieldName]"
                                [serverSide]="true"
                                [hasMore]="distinctHasMore[fieldName]"
                                [loadingMore]="distinctLoadingMore[fieldName]"
                                (searchChange)="onDistinctItemSearch(fieldName, $event)"
                                (loadMore)="onDistinctItemLoadMore(fieldName)"
                            >
                            </mat-select-search>
                        </ng-container>
                    }
                </ng-container>
            }
        </div>
    </div>

    <div class="dialog-footer flex flex-col-reverse sm:flex-row justify-end gap-2">
        <button
            mat-button
            (click)="closeDialog()"
            class="w-full sm:w-auto"
        >
            {{ t("Cancel") }}
        </button>
        <button
            mat-flat-button
            class="bg-primary w-full sm:w-auto"
            (click)="applyFilters()"
        >
            {{ t("Apply") }}
        </button>
    </div>
</div>
